var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: 1300, "footer-hide": true, title: "产品审核详情" },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _vm.innerSpin
                ? _c("Spin", { attrs: { size: "large", fix: "" } })
                : _vm._e(),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          staticClass: "small-form",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "种苗场" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.approveRecord.seedFarmName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "申请人" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.approveRecord.userPersonName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "申请时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.approveRecord
                                              .productApproveRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "申请数量" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.approveRecord
                                              .productApproveRecordAmount,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "审批状态" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.approveRecord
                                              .productApproveRecordProgress,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("Table", {
                        ref: "mainTable",
                        attrs: {
                          size: "small",
                          columns: _vm.mainTable.tableColumns,
                          data: _vm.approveProductList,
                          border: "",
                          stripe: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 16, type: "flex", justify: "end" },
                },
                [
                  _c(
                    "Col",
                    { attrs: { span: "2" } },
                    [
                      _vm.canUpdateApproveResult
                        ? _c(
                            "Button",
                            {
                              attrs: { type: "primary", size: "default" },
                              on: { click: _vm.onSave },
                            },
                            [_vm._v("审批更新")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("ProductPopupEdit", {
            attrs: {
              "popup-edit-resource": _vm.productPopup.popupEditResource,
              "product-uuid": _vm.productPopup.popupEditProductUuid,
              readonly: "",
            },
            model: {
              value: _vm.productPopup.popupEditModalShow,
              callback: function ($$v) {
                _vm.$set(_vm.productPopup, "popupEditModalShow", $$v)
              },
              expression: "productPopup.popupEditModalShow",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }